module.exports = __webpack_public_path__ + "img/five.5df61417.svg";